import { useNavigate, useLocation } from 'react-router-dom';
import React, { useState } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { ClipLoader } from 'react-spinners';
import { RiRefreshLine } from "react-icons/ri";
import { FaAngleLeft } from "react-icons/fa6";
import { FaSave } from "react-icons/fa";
import Pagination from '../pagination/pagination';
import { useSelector } from 'react-redux';
import { getName, getUserId, getUserName } from '../../../Redux/selecters';
import LeaseApiService from '../../services/apiService';
import moment from 'moment';
import { toast } from 'react-toastify';
import { FaFileCircleExclamation } from "react-icons/fa6";
const LeaseInvoiceApproval = () => {
    const [searchTerm, setSearchTerm] = useState({ value: 'Pending', label: 'Pending' });
    const [rowData, setRowData] = useState([]);
    const [loader, setloader] = useState(false);
    const [SupplierTab, setSupplierTab] = useState(true);
    const [POTab, setPOTab] = useState(true);
    const userName = useSelector(getUserId);
    const Name = useSelector(getUserName);
    const apiService = new LeaseApiService();

    const [colDefs, setColDefs] = useState([]);
    const [selectedItems, setSelectedItems] = useState([])
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const location = useLocation();
    const navigate = useNavigate();
    const leaseData = location.state;

    const [formData, setFormData] = useState({
        leaseNo: "",
    });
    const StatusFilter = [
        { value: 'Pending', label: 'Pending' },
        { value: 'Approved', label: 'Approved' },
        { value: 'Rejected', label: 'Rejected' },
    ]
    const handleFilter = (selectedOption) => {
        setSearchTerm(selectedOption)
    }
    const dateFormatter = (params) => {
        if (!params.value) return '---';
        const date = moment(params.value);
        return date.isValid() ? date.format("DD-MMM-YYYY") : '---';
    }
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        let value = momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1
        return value || '';
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setColDefs([
                {
                    headerName: "Approved", field: "isApproved", editable: false, suppressMovable: true, width: 90, pinned: 'left',
                    cellRenderer: (params) => (
                        <input
                            type="checkbox"
                            className='center'
                            style={{ width: "26.81px", height: "26.81px", border: "0.5px solid #7E57C2" }}
                            checked={params.data.isApproved}
                            onChange={(e) => handleCheckboxChange(params.data.voucherNo, 'isApproved', e.target.checked)}
                        />
                    )
                },
                {
                    headerName: "Rejected", field: "isRejected", editable: false, suppressMovable: true, width: 80, pinned: 'left',
                    cellRenderer: (params) => (
                        <input
                            type="checkbox"
                            className='center'
                            style={{ width: "26.81px", height: "26.81px", border: "0.5px solid #7E57C2" }}
                            checked={params.data.isRejected}
                            onChange={(e) => handleCheckboxChange(params.data.voucherNo, 'isRejected', e.target.checked)}
                        />
                    )
                },
                {
                    headerName: "Remarks", field: "approvalRemarks", editable: true, suppressMovable: true, width: 300,
                    valueFormatter: (params) => {
                        const remarks = params?.data?.approvalRemarks
                        return (remarks === "0" ? "" : remarks);
                    }
                },
                { headerName: "Invoice No", field: "voucherNo", filter: true, floatingfilter: true, suppressMovable: true, width: 150 },
                { headerName: "Property", field: "propertyName", editable: true, suppressMovable: true, width: 120 },
                { headerName: "Unit No", field: "unitNo", filter: true, floatingfilter: true, suppressMovable: true, width: 150 },
                { headerName: "Tenant", field: "tenantName", filter: true, floatingfilter: true, suppressMovable: true, width: 130 },
                { headerName: "Contact No", field: "contactNo", filter: true, floatingfilter: true, suppressMovable: true, width: 130 },
                { headerName: "Rent", field: "amount", filter: true, floatingfilter: true, suppressMovable: true, width: 130 },
                { headerName: "Vat", field: "vat", filter: true, floatingfilter: true, suppressMovable: true, width: 120 },
                { headerName: "Total", field: "invoiceTotal", filter: true, floatingfilter: true, suppressMovable: true, width: 120 },
                { headerName: "Approved By", field: "approvedBy", filter: true, floatingfilter: true, suppressMovable: true, width: 120 },
                {
                    headerName: "Approved On", field: "approvedDate", filter: true, floatingfilter: true, valueFormatter: dateFormatter,
                    comparator: dateComparator, suppressMovable: true, width: 120
                },
                { headerName: "Approval List", field: "approvalLevel", filter: true, floatingfilter: true, suppressMovable: true, width: 120 },
            ]);

            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', 20);
            params.append('UserNo', userName || '');
            params.append('IsRejected', searchTerm?.label === 'Rejected' ? true : false);
            params.append('IsApproved', searchTerm?.label === 'Approved' ? true : false);
            params.append('IsPending', searchTerm?.label === 'Pending' ? true : false);
            const res = await apiService.getApiParamater('GET_INVOICE_APPROVAL', `?${params.toString()}`);
            setRowData(res?.data?.result || []);
            setPagination(res.data.paginationData);
            setloader(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            // Handle error (e.g., show error message to user)
            setloader(false); // Set loading to false even in case of error
        }
    }
    const handleBackClick = () => {
        window.history.back();
    }
    const handleReset = () => {
        setloader(false);
        setFormData({ leaseNo: '' });
        setSearchTerm({ value: 'Pending', label: 'Pending' });
        navigate(location.pathname, { replace: true, state: null });
    }
    const handleRemarks = (event) => {
        const editedRow = rowData.find(row => row.voucherNo === event.data.voucherNo);
        if (editedRow) {
            editedRow[event.colDef.field] = event.value;
            setSelectedItems(prevItems => {
                const updatedItems = [...prevItems];
                const existingItemIndex = updatedItems.findIndex(item => item.docno === editedRow.voucherNo);

                if (existingItemIndex !== -1) {
                    updatedItems[existingItemIndex] = {
                        ...updatedItems[existingItemIndex],
                        [event.colDef.field]: event.value,
                    };
                } else {
                    updatedItems.push({ ...editedRow });
                }

                return updatedItems;
            });
        }
    }
    const handleCheckboxChange = async (voucherNo, field, isChecked) => {
        debugger
        // const params = new URLSearchParams();
        // params.append('Action', 'checkLeaseEditValidation');
        // params.append('LeaseNo', leaseNo);
        // const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
        // let data = res?.data?.result?.data
        // debugger
        // if (data?.length === 0) {
        setData(voucherNo, field, isChecked)
        // } else {
        //     if (data?.Invoices >= 0 && data?.Receipts === 0) {
        //         setData(leaseNo, field, isChecked)
        //     } else if (data?.Invoices > 0 || data?.Receipts > 0) {
        //         toast.warning("Invoices or Receipts created, Cannot Update Lease Status")
        //     }
        // }
    }
    const setData = (voucherNo, field, isChecked) => {
        setRowData(prevData => {
            return prevData.map(row => {
                if (row.voucherNo === voucherNo) {
                    const updatedRow = {
                        ...row,
                        isApproved: field === 'isApproved' ? isChecked : false,
                        isRejected: field === 'isRejected' ? isChecked : false
                    };

                    // Update selected items
                    setSelectedItems(prevItems => {
                        const updatedItems = [...prevItems];
                        const existingIndex = updatedItems.findIndex(item => item.voucherNo === voucherNo);

                        if (existingIndex !== -1) {
                            updatedItems[existingIndex] = { ...updatedItems[existingIndex], ...updatedRow };
                        } else {
                            updatedItems.push(updatedRow);
                        }

                        return updatedItems;
                    });

                    return updatedRow;
                }
                return row;
            });
        });

    }
    const proceedWithApiCall = async () => {
        const missingRemarks = selectedItems?.find(
            item => item.isRejected === true && (!item?.approvalRemarks || item?.approvalRemarks?.trim() === "0")
        );
        if (missingRemarks) {
            toast.error("Remarks are required for all rejected items.");
            return;
        }
        const body = {
            approvals: selectedItems.map(item => ({
                isApproved: item.isApproved || false,
                isRejected: item.isRejected || false,
                recordId: item?.recordId,
                leaseNo: item?.voucherNo,
                approvalLevel: item?.approvalLevel,
                approvalRemarks: item?.approvalRemarks || "0",
                review: item?.review,
                reviewDept: item?.reviewDept || "0",
                reviewTo: item?.reviewTo || "0",
                reviewRemarks: item?.reviewRemarks || "0",
            })),
            modifiedBy: Name
        };
        const response = await apiService.put('POST_INVOICE_APPROVAL', body);

        if (response?.data?.statusCode === 201 || response.data.statusCode === 200) {
            toast.success("Updated successfully.");
            getItems();
            setSelectedItems([]);
        } else {
            toast.error("Something went wrong during update.");
        }
    }
    const handleChange = async (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    }
    return (
        <div className='p-3'>
            <div className="cost-center-section">
                <div className="d-flexcursor-pointer slide-header"
                    onClick={() => setPOTab(!POTab)}>
                    <div className='h6 pt-1'>Invoices Approvals</div>
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="pb-3 row">
                            <div className="d-flex col-6 align-items-center">
                                <label className="form-label pt-1">Filter:</label>
                                {StatusFilter.map((status) => (
                                    <div key={status.value} className="form-check mx-2">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="statusFilter"
                                            id={status.value}
                                            value={status.value}
                                            checked={searchTerm.value === status.value}
                                            onChange={() => handleFilter(status)}
                                        />
                                        <label className="form-check-label" htmlFor={status.value}>
                                            {status.label}
                                        </label>
                                    </div>
                                ))}
                            </div>

                            <div className='col-6 d-flex gap-2'>
                                <div
                                    onClick={() => getItems()}
                                    className='mainbtnGry flex-end gap-2 w-25'>
                                    <FaFileCircleExclamation color='#fff' className='center mt-2 mx-2' />
                                    <div className='center'>Search</div>
                                </div>
                                {loader === true ?
                                    <div className='mainbtn flex-end gap-2  w-25'><ClipLoader color="#ffffff" size={25} /></div> :
                                    <div
                                        onClick={() => proceedWithApiCall()}
                                        className='mainbtn flex-end gap-2  w-25'>
                                        <FaSave color='#fff' className='center mt-2 mx-2' />
                                        <div className='center'>Save</div>
                                    </div>
                                }
                                <div
                                    onClick={() => handleReset()}
                                    className='mainbtnRed flex-end gap-2  w-25'>
                                    <RiRefreshLine color='#fff' className='center mt-2 mx-2' />
                                    <div className='center'>Reset</div>
                                </div>
                                <div
                                    onClick={() => handleBackClick()}
                                    className='mainbtn flex-end gap-2  w-25'>
                                    <FaAngleLeft color='#fff' className='center mt-2 mx-2' />
                                    <div className='center'>Back</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className='h6 pt-1'>Approval List</div>
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 ${SupplierTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="ag-theme-quartz" style={{ height: 500, suppressMovable: true, width: '100%' }}>
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={colDefs}
                                onCellValueChanged={handleRemarks}
                                suppressRowClickSelection={true}
                                getRowStyle={(params) => {
                                    return params.node.rowIndex % 2 === 0
                                        ? { background: '#F0EDF5' }
                                        : { background: '#fff' };
                                }}
                            />
                        </div>
                        <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
                    </div>
                </div>
            </div>
        </div >
    )
}

export default LeaseInvoiceApproval;
